import React, { useState, useEffect } from 'react';
import '../../App.css';
import Select, { components } from 'react-select';

import { collection, addDoc, getDocs, Timestamp, doc, updateDoc } from "firebase/firestore";
import { useLocation } from 'react-router-dom';
import { db } from './../../firebaseConfig';

function Contactus() {
  const [companies, setCompanies] = useState([]);
  const [talents, setTalents] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState('');
  const [bookingDetails, setBookingDetails] = useState(null);
  const [editingbokkingTalent, setEditingbookingTalent] = useState('');
  const [editingbokkingTalentid, setEditingbookingTalentid] = useState('');
  const [editingbookingCompany, setEditingbookingcompany] = useState('');
  const [loading, setLoading] = useState(true);

  const [title, setTitle] = useState('TITLE ');
  const [description, setDescription] = useState('DESCRIPTION');
  const [kpi, setKpi] = useState('KPI');
  const [set, setSet] = useState('SET');
  const [ends_on, setEnds_on] = useState('');
  const [period, setPeriod] = useState('');

  const [talent, setTalent] = useState("");
  const [talentId, setTalentId] = useState(' ');
  const [rate, setRate] = useState(' ');
  const [costumer, setCostumer] = useState(' ');

  const options = [
    { value: 'new order', label: 'New order' },
    { value: 'optioned', label: 'Optioned' },
    { value: 'talentaccepted', label: 'Accepted by talent' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'lano', label: 'Lano' }
  ];
  const position = [
    { value: 'H&M', label: 'H&M' },
    { value: 'AD', label: 'AD' },
    { value: 'etc', label: 'etc' },
 
  ];
  const location = useLocation();
  const bookingId = new URLSearchParams(location.search).get('bookingId');
  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      border: 'none',
    }),
    control: (base) => ({
      ...base,
      width: '400px',
      borderColor: 'black',
      borderWidth: '1px',
      boxShadow: 'none',
      margin: '5px',
      borderRadius: '0px',
      color: 'black', // Your color
      fontWeight: "700",
      height: '50px',
      textTransform: 'uppercase',

    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black', // Your color
      fontWeight: "700"
    }),
    input: (provided) => ({
      ...provided,
      color: 'black', // Your color
      fontWeight: "700"
    }),
  };

  const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: '16px', margin: '0' }}>
            <svg version="1.1" id="Isolationsmodus" x="0px" y="0px" viewBox="0 0 322.9 257.78" shapeRendering="geometricPrecision">
              <path xmlns="http://www.w3.org/2000/svg" d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z" />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };


  const [selectedOption, setSelectedOption] = React.useState(null);
  const [selectedPosition, setselectedPosition] = React.useState(null);
  const handleOptionChange = selectedOption => {

    setSelectedOption(selectedOption);
  }


  const handlePostionchange = selectedPosition => {

    setselectedPosition(selectedPosition);
  }


  useEffect(() => {
    // Fetch companies and talents
    const fetchCompaniesAndTalents = async () => {
      const companySnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/company"));
      const talentSnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talents"));

      const companyData = companySnap.docs.map(doc => ({
        value: doc.id,
        label: doc.data().name  // assumes the company document has a 'name' field
      }));
      const talentData = talentSnap.docs.map(doc => ({
        value: doc.id,
        label: doc.data().name,  // assumes the talent document has a 'name' field
        email: doc.data().email
      }));

      setCompanies(companyData);
      setTalents(talentData);

      // If bookingId is present, fetch the booking details
      // If bookingId is present, fetch the booking details
      if (bookingId) {
        const bookingSnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/Bookings"));
        const bookingData = bookingSnap.docs.find(doc => doc.id === bookingId);


        if (bookingData) {
          setBookingDetails(bookingData.data());
          let companyID = bookingData.data().companyID.split('/').pop(); // Split the string at '/' and get the last element
        
          let company = companyData.find(company => company.value === companyID); // Use the extracted id to find the company
        
       
          setEditingbookingcompany(company.label);
          setSelectedCompany(company.label);
          
          setStartDate(bookingData.data().start_date.toDate().toLocaleDateString().split('T')[0]);
          setEndDate(bookingData.data().end_date.toDate().toLocaleDateString().split('T')[0]);
          setStatus(bookingData.data().status);
          let talentid = bookingData.data().talentId.split('/').pop(); // Split the string at '/' and get the last element
          let talents = talentData.find(talent => talent.value === talentid); // Use the extracted id to find the company
          setEditingbookingTalent(talents.label);
          setEditingbookingTalentid(talents.value);
          setSelectedTalent(talents.label);
        }
      }


      setLoading(false);
    };

    fetchCompaniesAndTalents();
  }, []);




  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };

  const handleTalentChange = (selectedOption) => {
    setSelectedTalent(selectedOption);
  };
  const createmail = async (talentEmail, newValue) => {
    const msg = {
      to: talentEmail,
      message: {
        subject: 'New Booking ',
        text: `A new booking has been made. Details: ${JSON.stringify(newValue)}`,
        html: `
            Dear  ${newValue.talentId},
        
        
            <p>A new booking has been made.</p>
          
            <p>  Status:  ${newValue.status}</p>
            <p>  StartDate:  ${newValue.startDate} </p>
            <p>  End Date:  ${newValue.endDate} </p>
            <p>  Freelancer:  ${newValue.talentId} </p>
            <p>  Compant:  ${newValue.company} </p>
            http://dev-setcast.mondula.com/
           
            
            
            </p>`,
      },
    };


    await addDoc(collection(db, "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/mail"), msg);
  };

  const checkForBookingConflicts = async (startDate, endDate, talentId, excludeBookingId) => {
    // Fetch all bookings for the selected talent
    const bookingSnap = await getDocs(collection(db, 'SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/Bookings'));
    let talentBookings = bookingSnap.docs.filter(doc => doc.data().talentId === `/talents/${talentId}`);
    
    if(excludeBookingId){
      talentBookings = talentBookings.filter(doc => doc.id !== excludeBookingId);
    }
  
    // Convert new booking dates to Date objects
    const newBookingStartDate = new Date(startDate);
    const newBookingEndDate = new Date(endDate);
  
    // Check if new booking dates conflict with existing bookings
    return talentBookings.some(booking => {
      const bookingStartDate = new Date(booking.data().start_date.toDate());
      const bookingEndDate = new Date(booking.data().end_date.toDate());
  
      // Check for overlaps and exact matches
      return ((bookingStartDate < newBookingEndDate && bookingEndDate > newBookingStartDate) ||
        (bookingStartDate.getTime() === newBookingStartDate.getTime() && bookingEndDate.getTime() === newBookingEndDate.getTime()));
    });
  };
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Check if it's a new booking or an update
    if (bookingId) {
      // Update existing booking
      try {
        const bookingRef = doc(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/Bookings", bookingId);
  
        const isConflict = await checkForBookingConflicts(startDate, endDate, editingbokkingTalentid, bookingId);
        if (isConflict) {
          alert("Error: Talent is already booked within the selected dates.");
        } else {
          await updateDoc(bookingRef, {
            start_date: Timestamp.fromDate(new Date(startDate)),
            end_date: Timestamp.fromDate(new Date(endDate)),
           
            talentId: `/talents/${selectedTalent.value}`,
            status: selectedOption.value,
          });
  
          alert("Booking updated successfully.");
        }
      } catch (error) {
        console.error("Error updating booking: ", error);
      }
    } else {
      try {
        const isConflict = await checkForBookingConflicts(startDate, endDate, selectedTalent.value);
        if (isConflict) {
          alert("Error: Talent is already booked within the selected dates.");
        } else {
          const newBookingStartDate = new Date(startDate);
          const newBookingEndDate = new Date(endDate);
        
          const newBooking = {
            companyID: `/company/${selectedCompany.value}`,
            talentId: `/talents/${selectedTalent.value}`,
            start_date: Timestamp.fromDate(newBookingStartDate),
            end_date: Timestamp.fromDate(newBookingEndDate),
            status: selectedOption.value,
          };
        
          await addDoc(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/Bookings"), newBooking);
          alert("Booking added successfully.");
        
          const newValue = {
            company: selectedCompany.label,
            talentId: selectedTalent.label,
            startDate: newBookingStartDate,
            endDate: newBookingEndDate,
            status: newBooking.status,
          };
        
          // Pass the selected talent's email and the new booking value to your sendmail function
          await createmail(selectedTalent.email, newValue);
        }
        
      } catch (e) {
        console.error("Error adding booking: ", e);
      }
    }
  };
  





  useEffect(() => {
    if (startDate === "") {
      document.getElementById("start-date").placeholder = "Start Date";
    }

    if (endDate === "") {
      document.getElementById("end-date").placeholder = "End Date";
    }
  }, [startDate, endDate]);

  return (
    <div className="wrapper">


      <h1 className='h1'>{bookingId ? 'Update Booking' : 'Create Booking'}</h1>

      <form onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '400px',
       

        }}
      >
        {bookingId ? (

          // If bookingId exists, render your 'editing' JSX here, example:
          <div style={{ width: '100%', textTransform: 'uppercase' }} >
            <p>Company: <strong>{editingbookingCompany}</strong></p>
            <p>Talent: <strong>{editingbokkingTalent}</strong></p>
            <Select
              components={{ DropdownIndicator }}
              options={talents}
              onChange={handleTalentChange}
              placeholder="TALENT"
              styles={customStyles}
            />


          </div>
        ) : (
          <>
            <Select
              components={{ DropdownIndicator }}
              options={companies}
              onChange={handleCompanyChange}
              placeholder="COMPANY"
              styles={customStyles}
            />
            <Select
              components={{ DropdownIndicator }}
              options={talents}
              onChange={handleTalentChange}
              placeholder="TALENT"
              styles={customStyles}
            />
          </>
        )}
          <input className='inputtext' type="text" value={title} onChange={(e) => setTitle(e.target.value)} required placeholder='First Name'/>
          <input className='inputtext' type="text" value={description} onChange={(e) => setDescription(e.target.value)} required placeholder='First Name'/>
          <input className='inputtext' type="text" value={kpi} onChange={(e) => setKpi(e.target.value)} required placeholder='First Name'/>
          <input className='inputtext' type="text" value={set} onChange={(e) => setSet(e.target.value)} required placeholder='First Name'/>


          <Select
          components={{ DropdownIndicator }}
          options={position}
          onChange={handlePostionchange}
          placeholder="Position"
          value={selectedPosition}
          styles={customStyles}
        />
        <Select
          components={{ DropdownIndicator }}
          options={options}
          onChange={handleOptionChange}
          placeholder="STATUS"
          value={selectedOption}
          styles={customStyles}
        />

        <div style={{ display: 'flex' }}>
          <div className="date-input-wrapper">
            <input className='inputdate' id="start-date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
            <svg className="custom-icon" viewBox="0 0 500 500" >
              <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
            </svg>
          </div>

          <div className="date-input-wrapper">
            <input className='inputdate' id="end-date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} required placeholder='END' />
            <svg className="custom-icon" viewBox="0 0 500 500" >
              <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
            </svg>
          </div>
        </div>

        <div className='button-wrapper'>
          <button className='button' type="submit">{bookingId ? 'Update Booking' : 'Create Booking'}</button>

        </div>
      </form>
    </div>
  );
}

export default Contactus;
